import script from "./TextareaField.vue?vue&type=script&setup=true&lang=js"
export * from "./TextareaField.vue?vue&type=script&setup=true&lang=js"

import "./TextareaField.vue?vue&type=style&index=0&id=9d96a9c0&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d96a9c0"]])

export default __exports__